import * as api from '../api/billing-reasons';
import q from '../query';
export const billingReasonKey = (depositCaseVoucherId, billingId) => `billing-reason-${billingId}-${depositCaseVoucherId}`;
export const useBillingReasons = (depositCaseVoucherId, billingId) => q.query(billingReasonKey(depositCaseVoucherId, billingId), () => api.get(depositCaseVoucherId, billingId), []);
//# sourceMappingURL=index.js.map